var tagalysConfiguration = {
  api: {
    serverUrl: "https://api-r3.tagalys.com",
    credentials: {
      clientCode: "9A22EFCF79C92769",
      apiKey: "ebfcd828c7e10ce4226e2eb269f658ae",
    },
    storeId: "78538178836",
  },
  locale: "en-US",
  currency: {
    displayFormatter: "{{currencyLabel}}{{value}}",
    code: "USD",
    label: "$",
    fractionalDigits: 2,
    forceFractionalDigits: true,
  },
  analyticsStorageConsentProvided: function () {
    // return true/false based on user's consent settings
    return true;
  },
  track: true,
};
var platformConfiguration = {
  platform: "Shopify",
  countryCode: "US", // replace with Shopify.country to set the shopper's chosen country
  baseCountryCode: "US",
  useStorefrontAPIForSecondaryMarkets: true,
  waitForStorefrontAPI: true,
  storefrontAPI: {
    accessToken: "842422896fd58111e8664a23effaee18",
    myShopifyDomain: "2f0eb1.myshopify.com",
  },
  metafields: {
    products: [],
  },
};

var TagalysCustomisations = {};

TagalysCustomisations.setTagalysConfiguration = function () {
  Tagalys.setConfiguration(tagalysConfiguration);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

TagalysCustomisations.initSearchSuggestions = function () {
  Tagalys.UIWidgets.SearchSuggestions.init( [".block__header-search-desktop [data-search-input]", ".search-modal [data-search-input]"], {
    searchResultsURL: "/search.html",
    });
};





TagalysCustomisations.initSearchResults = function () {
  Tagalys.UIWidgets.SearchResults.init("[data-search-results]", {
    templates: {
      noResults: {
        options: {
          widgets: [
            {
              widgetId: "d67a42627063856dd686",
            },
          ],
        },
      },
      filters: {
        options: {
          showFiltersInDrawer: true
        }
      }
    },
  });
};

TagalysCustomisations.initSmartWidget = function () {
  Tagalys.UIWidgets.SmartWidget.init("[data-smart-widget]", {
    widgetId: "d67a42627063856dd686"
  })
}

TagalysCustomisations.initCrossSelling = function () {
  Tagalys.UIWidgets.Recommendations.init("[data-cross-selling]", {
    recommendationId: "c4c3db9470f385935726",
    productId: "8968653832468"
  })
}

TagalysCustomisations.initSimilarProducts = function () {
  Tagalys.UIWidgets.Recommendations.init("[data-similar-products]", {
    recommendationId: "fb0741830bf36db49d64",
    productId: "8905331704084"
  })
}

TagalysCustomisations.initShopifyProductListingPage = function () {
  Tagalys.UIWidgets.ShopifyProductListingPage.init("[data-product-listing-page]", {
    params: {
      product_listing_page_id: "473217040660"
    }
  });
}
